/**
 * Created by Анжелика on 23.08.2017.
 */
import {combineReducers} from 'redux';
import {login} from './login';
import {registration} from './registration';
import {userData} from './userData';
import {appContent} from "./appContent";
import {genres} from './genres';
import {channels} from './channels';
import {channelLink} from './channelLink';
import {video} from './video';
import {epg} from './epg';
import {channelCards} from './channelCards';
import {favorites} from './favorites';

const rootReducer = combineReducers({
        users: combineReducers({
            login,
            registration,
            userData
        }),
        appContent,
        genres,
        channels,
        channelLink,
        video,
        epg,
        channelCards,
        favorites
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js